// extracted by mini-css-extract-plugin
export var Section = "page-module--Section--xb-zL";
export var SectionLinksContainer = "page-module--SectionLinksContainer--TZYA7";
export var Container = "page-module--Container--52vB2";